'use client';

import Link from 'next/link';

export default function PoliticaDePrivacidadePage() {
  const currentYear = new Date()?.getFullYear();

  return (
    <div style={{ backgroundColor: '#F8F9FA', minHeight: '100vh', fontFamily: 'DM Sans, sans-serif' }}>
      {/* Header */}
      <header style={{ backgroundColor: '#FFFFFF', borderBottom: '1px solid rgba(0,0,0,0.08)' }}>
        <div className="max-w-6xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link href="/landing-page" aria-label="GestPub — Gestão Pública e Consultoria Autárquica — Página inicial" className="inline-block focus-visible:outline-none">
            <img
              src="/assets/images/6-1773621431219.png"
              alt="GestPub — Gestão Pública e Consultoria Autárquica"
              style={{ height: 38, width: 'auto', display: 'block', flexShrink: 0, mixBlendMode: 'multiply' }}
            />
          </Link>
          <Link
            href="/landing-page"
            style={{ fontSize: '0.82rem', color: '#6B7280', textDecoration: 'none' }}
            onMouseEnter={(e) => (e.currentTarget.style.color = '#272727')}
            onMouseLeave={(e) => (e.currentTarget.style.color = '#6B7280')}
          >
            Voltar à página inicial
          </Link>
        </div>
      </header>
      {/* Teal accent line */}
      <div className="h-1" style={{ backgroundColor: '#009688' }} />
      {/* Content */}
      <main className="max-w-3xl mx-auto px-6 py-14">
        {/* Page title */}
        <div className="mb-10">
          <p style={{ fontSize: '0.75rem', letterSpacing: '0.12em', textTransform: 'uppercase', color: '#009688', fontWeight: 600, marginBottom: '0.75rem' }}>
            GestPub, Serviço GP Otimiza
          </p>
          <h1 style={{ fontSize: '2rem', fontWeight: 700, color: '#272727', lineHeight: 1.25, marginBottom: '1rem' }}>
            Política de Privacidade
          </h1>
          <p style={{ fontSize: '0.85rem', color: '#6B7280' }}>
            Última atualização: março de {currentYear}
          </p>
        </div>

        <div style={{ backgroundColor: '#FFFFFF', borderRadius: 10, border: '1px solid rgba(0,0,0,0.08)', padding: '2.5rem' }}>
          <div className="space-y-8" style={{ color: '#374151', lineHeight: 1.75, fontSize: '0.92rem' }}>

            <section>
              <h2 style={{ fontSize: '1.1rem', fontWeight: 700, color: '#272727', marginBottom: '0.75rem' }}>1. Identificação do Responsável pelo Tratamento</h2>
              <p>
                A <strong>GestPub – Gestão Pública e Consultoria Autárquica, Lda.</strong> é a entidade responsável pelo tratamento dos dados pessoais recolhidos através da plataforma de diagnóstico GP Otimiza, um serviço da GestPub dedicado ao apoio à modernização organizacional de municípios portugueses.
              </p>
              <ul className="mt-3 space-y-1" style={{ paddingLeft: '1.25rem', listStyleType: 'disc' }}>
                <li><strong>Denominação social:</strong> GestPub – Gestão Pública e Consultoria Autárquica, Lda.</li>
                <li><strong>Sede:</strong> Avenida da República, Ed. República, 1.º Piso, Escritório E, Alcoitão, 2645-143 Estoril</li>
                <li><strong>Endereço eletrónico:</strong> geral@gestpub.pt</li>
                <li><strong>Telefone:</strong> (+351) 214 846 546</li>
              </ul>
            </section>

            <section>
              <h2 style={{ fontSize: '1.1rem', fontWeight: 700, color: '#272727', marginBottom: '0.75rem' }}>2. Âmbito e Finalidade do Tratamento</h2>
              <p>
                A presente Política de Privacidade aplica-se à plataforma de diagnóstico organizacional GP Otimiza, desenvolvida e disponibilizada pela GestPub no âmbito do seu serviço de modernização e consultoria autárquica. Os dados pessoais recolhidos destinam-se exclusivamente às seguintes finalidades:
              </p>
              <ul className="mt-3 space-y-1.5" style={{ paddingLeft: '1.25rem', listStyleType: 'disc' }}>
                <li>Geração do relatório de diagnóstico de capacidade organizacional municipal;</li>
                <li>Contacto posterior pela equipa da GestPub para apresentação de propostas de intervenção, caso o utilizador o solicite expressamente;</li>
                <li>Envio de informação institucional sobre o serviço GP Otimiza e sobre a oferta da GestPub, mediante consentimento explícito;</li>
                <li>Melhoria contínua da plataforma e dos instrumentos de diagnóstico utilizados.</li>
              </ul>
            </section>

            <section>
              <h2 style={{ fontSize: '1.1rem', fontWeight: 700, color: '#272727', marginBottom: '0.75rem' }}>3. Dados Pessoais Recolhidos</h2>
              <p>No âmbito do diagnóstico, a GestPub recolhe os seguintes dados pessoais:</p>
              <ul className="mt-3 space-y-1.5" style={{ paddingLeft: '1.25rem', listStyleType: 'disc' }}>
                <li>Nome completo;</li>
                <li>Município de representação;</li>
                <li>Cargo ou função desempenhada;</li>
                <li>Endereço de correio eletrónico institucional;</li>
                <li>Número de telefone (facultativo);</li>
                <li>Respostas ao questionário de diagnóstico organizacional.</li>
              </ul>
              <p className="mt-3">
                Não são recolhidos dados sensíveis na aceção do artigo 9.º do Regulamento Geral sobre a Proteção de Dados (RGPD).
              </p>
            </section>

            <section>
              <h2 style={{ fontSize: '1.1rem', fontWeight: 700, color: '#272727', marginBottom: '0.75rem' }}>4. Base Legal do Tratamento</h2>
              <p>O tratamento dos dados pessoais assenta nas seguintes bases legais, nos termos do artigo 6.º do RGPD:</p>
              <ul className="mt-3 space-y-1.5" style={{ paddingLeft: '1.25rem', listStyleType: 'disc' }}>
                <li><strong>Consentimento do titular</strong> (artigo 6.º, n.º 1, alínea a): para o envio de comunicações informativas e para o eventual acompanhamento pela GestPub;</li>
                <li><strong>Interesse legítimo</strong> (artigo 6.º, n.º 1, alínea f): para a geração do relatório de diagnóstico e para a melhoria dos instrumentos de avaliação organizacional.</li>
              </ul>
            </section>

            <section>
              <h2 style={{ fontSize: '1.1rem', fontWeight: 700, color: '#272727', marginBottom: '0.75rem' }}>5. Conservação dos Dados</h2>
              <p>
                Os dados pessoais são conservados pelo período estritamente necessário à prossecução das finalidades para as quais foram recolhidos. Em regra, os dados são mantidos por um período máximo de 24 meses a contar da data de submissão do diagnóstico, salvo obrigação legal de conservação por prazo superior ou exercício de direitos pelo titular.
              </p>
            </section>

            <section>
              <h2 style={{ fontSize: '1.1rem', fontWeight: 700, color: '#272727', marginBottom: '0.75rem' }}>6. Partilha de Dados com Terceiros</h2>
              <p>
                A GestPub não partilha os dados pessoais recolhidos com terceiros para fins comerciais ou de marketing. Os dados poderão ser partilhados com subcontratantes que prestem serviços de suporte tecnológico à plataforma, mediante celebração de contratos de tratamento de dados que garantam o cumprimento do RGPD. Não são realizadas transferências de dados para países terceiros fora do Espaço Económico Europeu.
              </p>
            </section>

            <section>
              <h2 style={{ fontSize: '1.1rem', fontWeight: 700, color: '#272727', marginBottom: '0.75rem' }}>7. Direitos dos Titulares</h2>
              <p>Nos termos do RGPD, os titulares dos dados têm direito a:</p>
              <ul className="mt-3 space-y-1.5" style={{ paddingLeft: '1.25rem', listStyleType: 'disc' }}>
                <li><strong>Acesso</strong> aos dados pessoais que lhes digam respeito;</li>
                <li><strong>Retificação</strong> de dados inexatos ou incompletos;</li>
                <li><strong>Apagamento</strong> dos dados, nos casos previstos na lei;</li>
                <li><strong>Limitação</strong> do tratamento, em determinadas circunstâncias;</li>
                <li><strong>Portabilidade</strong> dos dados, quando aplicável;</li>
                <li><strong>Oposição</strong> ao tratamento baseado em interesse legítimo;</li>
                <li><strong>Retirada do consentimento</strong>, a qualquer momento, sem prejuízo da licitude do tratamento anterior.</li>
              </ul>
              <p className="mt-3">
                Para exercer qualquer um destes direitos, o titular pode contactar a GestPub através do endereço eletrónico <a href="mailto:geral@gestpub.pt" style={{ color: '#009688' }}>geral@gestpub.pt</a>. O titular tem ainda o direito de apresentar reclamação à Comissão Nacional de Proteção de Dados (CNPD), autoridade de controlo competente em Portugal.
              </p>
            </section>

            <section>
              <h2 style={{ fontSize: '1.1rem', fontWeight: 700, color: '#272727', marginBottom: '0.75rem' }}>8. Segurança dos Dados</h2>
              <p>
                A GestPub adota medidas técnicas e organizativas adequadas para garantir a segurança dos dados pessoais tratados, prevenindo o acesso não autorizado, a divulgação indevida, a alteração ou a destruição acidental dos dados. As medidas implementadas são revistas e atualizadas periodicamente em função da evolução tecnológica e dos riscos identificados.
              </p>
            </section>

            <section>
              <h2 style={{ fontSize: '1.1rem', fontWeight: 700, color: '#272727', marginBottom: '0.75rem' }}>9. Alterações à Política de Privacidade</h2>
              <p>
                A presente Política de Privacidade pode ser atualizada periodicamente para refletir alterações legais, regulatórias ou operacionais. A versão mais recente estará sempre disponível nesta página, com indicação da data da última atualização. Recomenda-se a consulta regular deste documento.
              </p>
            </section>

            <section>
              <h2 style={{ fontSize: '1.1rem', fontWeight: 700, color: '#272727', marginBottom: '0.75rem' }}>10. Contacto</h2>
              <p>
                Para qualquer questão relacionada com o tratamento dos seus dados pessoais ou com a presente Política de Privacidade, pode contactar a GestPub através dos seguintes meios:
              </p>
              <ul className="mt-3 space-y-1.5" style={{ paddingLeft: '1.25rem', listStyleType: 'disc' }}>
                <li>Correio eletrónico: <a href="mailto:geral@gestpub.pt" style={{ color: '#009688' }}>geral@gestpub.pt</a></li>
                <li>Telefone: (+351) 214 846 546</li>
                <li>Morada: Avenida da República, Ed. República, 1.º Piso, Escritório E, Alcoitão, 2645-143 Estoril</li>
              </ul>
            </section>

          </div>
        </div>
      </main>
      {/* Footer */}
      <footer style={{ backgroundColor: '#272727' }}>
        <div className="h-1" style={{ backgroundColor: '#009688' }} />
        <div className="max-w-6xl mx-auto px-6 py-6 flex flex-col md:flex-row justify-between items-center gap-4">
          <p style={{ fontFamily: 'DM Sans, sans-serif', fontSize: '0.78rem', color: 'rgba(255,255,255,0.35)' }}>
            &copy; {currentYear} GestPub – Gestão Pública e Consultoria Autárquica. Todos os direitos reservados.
          </p>
          <div className="flex gap-6">
            {[
              { label: 'Política de Privacidade', href: '/politica-de-privacidade' },
              { label: 'Termos de Utilização', href: '/termos-de-utilizacao' },
              { label: 'RGPD', href: '/rgpd' },
            ]?.map((link) => (
              <Link
                key={link?.label}
                href={link?.href}
                className="transition-colors duration-200"
                style={{ fontFamily: 'DM Sans, sans-serif', fontSize: '0.78rem', color: link?.href === '/politica-de-privacidade' ? '#FFFFFF' : 'rgba(255,255,255,0.35)', textDecoration: 'none' }}
                onMouseEnter={(e) => (e.currentTarget.style.color = '#FFFFFF')}
                onMouseLeave={(e) => (e.currentTarget.style.color = link?.href === '/politica-de-privacidade' ? '#FFFFFF' : 'rgba(255,255,255,0.35)')}
              >
                {link?.label}
              </Link>
            ))}
          </div>
        </div>
      </footer>
    </div>
  );
}
